import React, { useState } from "react";

import bosniaFlag from "../../../../../../../../shared/resources/bos.png";
import jamaicaFlag from "../../../../../../../../shared/resources/jam.png";
import malaysiaFlag from "../../../../../../../../shared/resources/mal.png";
import sriLankaFlag from "../../../../../../../../shared/resources/sl.png";
import indianFlag from "../../../../../../../../shared/resources/ind.png";
import indonesiaFlag from "../../../../../../../../shared/resources/indo.png";
import { useAppUser } from "../../../../../../../../contexts/user-context/UserContext";
import { useWorkshops } from "../../../../../../../../contexts/workshops-context/WorkshopsContext";
import SelectCountry from "../../../../../../../../shared/components/countrySelectorModal/SelectCountry";
import { Country } from "../../../../../../../../shared/constants/Constant";
import CountryWithFlag from "../../courses/components/header/CountryWithFlag";

const AnnoucementSideBarHeader = () => {
  const workshops = useWorkshops();
  const appUser = useAppUser();
  const [modalShow, setModalShow] = useState(false);

  return (
    <div
      className="text-left px-4 pt-4 lsb-wrapper "
      style={{
        height: "175px",
        background:
          "linear-gradient(90deg, rgba(255,255,255,1) 50%, rgba(220,220,220,1) 100%)",
      }}
    >
      <h6 className="mb-0 font-weight-bold" style={{ color: "#07425E" }}>
        IEEE INNOVATION NATION
      </h6>
      <h3 className="font-weight-bold" style={{ color: "#07425E" }}>
        NOTICES
      </h3>

      {!appUser.userRole.isAdmin && appUser.userRole.isMember && (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            appUser.userRole.isAdmin && setModalShow(true);
          }}
        >
          {workshops.country === Country.SRI_LANKA ? (
            <CountryWithFlag flag={sriLankaFlag} name={"Sri Lanka"} />
          ) : workshops.country === Country.JAMAICA ? (
            <CountryWithFlag flag={jamaicaFlag} name={"Jamaica"} />
          ) : workshops.country === Country.INDIA ? (
            <CountryWithFlag flag={indianFlag} name={"India"} />
          ) : workshops.country === Country.INDONESIA ? (
            <CountryWithFlag flag={indonesiaFlag} name={"Indonesia"} />
          ) : workshops.country === Country.MALAYSIA ? (
            <CountryWithFlag flag={malaysiaFlag} name={"Malaysia"} />
          ) : (
            workshops.country === Country.BOSNIA && (
              <CountryWithFlag flag={bosniaFlag} name={"Bosnia"} />
            )
          )}
        </div>
      )}

      <SelectCountry
        show={modalShow}
        onHide={() => {
          setModalShow(false);
        }}
      />
    </div>
  );
};

export default AnnoucementSideBarHeader;
